import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Input, Radio, Checkbox } from 'antd';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  select: {
    backgroundColor: 'white',
    border: '2px solid #5564F8 !important',
    borderRadius: '10px',
    boxSizing: 'border-box',
    outline: 'none !important'
  },
  selectRow: {
    border: '1px solid #CAD8FF',
    borderRadius: '10px',
    boxSizing: 'border-box',
    height: '200px',
    width: '356px'
  },
  unselect: {
    backgroundColor: 'white',
    border: '1px solid #CAD8FF',
    borderRadius: '10px',
    boxSizing: 'border-box'
  },
  unselectRow: {
    height: '86px',
    width: '356px'
  }
  // root: {
  //   "& .MuiOutlinedInput-root": {
  //     borderRadius: "10px",
  //     zIndex: 1,
  //     "& fieldset": {
  //       borderColor: "#CAD8FF",
  //       backgroundColor: "white",
  //       zIndex: -1,
  //     },
  //   },
  //   "& .MuiFormLabel-root": {
  //     color: "#000000",
  //     fontFamily: "Poppins",
  //     zIndex: 2,
  //   },
  // },
});

const BankCard = ({ id, logo, name, date, code, selectState, selectedId, setSelectedId }) => {
  const classes = useStyles();
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(selectedId === id);
    if (selectState) {
      setSelected(false);
    }
  }, [id, selectedId, selectState]);

  return (
    <Row
      className={selected ? classes.selectRow : classes.unselectRow}
      style={{
        marginBottom: '16px',
        width: '356px'
      }}
    >
      <Layout
        className={selected ? classes.select : classes.unselect}
        style={{
          backgroundColor: 'white',
          border: '1px solid #CAD8FF',
          borderRadius: '10px',
          boxSizing: 'border-box',
          height: '86px'
        }}
      >
        <Row onClick={() => setSelectedId(selected ? null : id)}>
          <Col
            style={{
              marginLeft: '20px',
              marginTop: '30px'
            }}
          >
            <Radio checked={selected} />
          </Col>
          <Col
            style={{
              marginLeft: '12px',
              marginTop: '28px'
            }}
          >
            {logo}
          </Col>
          <Col style={{ marginLeft: '16px', marginTop: '24px' }}>
            <Row style={{ fontWeight: 'bold', width: '100%' }}>{name}</Row>
            <Row>{date}</Row>
          </Col>
          <Col
            style={{
              fontWeight: 'bold',
              marginLeft: '100px',
              marginTop: '24px'
            }}
          >
            {`**** ${code}`}
          </Col>
        </Row>
        {selected ? (
          <div>
            <Row
              style={{
                alignItems: 'center',
                border: 'none',
                justifyContent: 'center',
                marginTop: '35px'
              }}
            >
              <Input
                placeholder="CVC"
                style={{
                  background: '#FFFFFF',
                  border: '1px solid #CAD8FF',
                  borderRadius: '14px',
                  boxSizing: 'border-box',
                  height: '40px',
                  width: '324px'
                }}
              />
            </Row>
            <Row
              style={{
                marginLeft: '20px',
                marginTop: '15px'
              }}
            >
              <Checkbox>Set as Default Payment Method</Checkbox>
            </Row>
          </div>
        ) : null}
      </Layout>
    </Row>
  );
};

export default BankCard;
